(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberRoles', {
            templateUrl: 'app/member-admin/member-roles/member-roles.component.html',
            controller: RolesComponent,
            bindings: {
                individualId: '<',
                roles: '<',
                roleList: '<',
                createRole: '<'
            }
        });

    var noop = angular.noop;

    RolesComponent.$inject = ['Member', 'alert', 'confirm', 'memberAdminResources'];
    function RolesComponent(Member, alert, confirm, resources) {
        var ctrl = this;

        ctrl.insert = insert;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.remove = remove;
        ctrl.cancel = cancel;

        function insert() {
            var role = ctrl.createRole({ individualId: ctrl.individualId })
            ctrl.roles.push(role);
            ctrl.edit(role);
        }

        function edit(role) {
            role.$edit();
        }

        function save(role, form) {
            if (form.$valid) 
                Member.saveRole({ id: ctrl.individualId }, role, success, error, true);

            function success(data) {
                role.$commit(data);
            }

            function error() {
                alert.error(resources.saveRoleFailed);
            }
        }

        function remove(role) {
            confirm(resources.confirmDeleteRole).then(remove, noop);

            function remove() {
                Member.deleteRole({ id: ctrl.individualId }, role, success, error, true);

                function success() {
                    removeFromArray(role);
                }

                function error() {
                    alert.error(resources.deleteRoleFailed);
                }
            }
        }

        function cancel(role) {
            role.$rollback();
            if (!role.oldRoleId)
                removeFromArray(role)
        }

        function removeFromArray(role) {
            var index = ctrl.roles.indexOf(role);
            if (index != -1)
                ctrl.roles.splice(index, 1);
        }
    }
})();